import React from 'react'
import { HotelCrossSellModalWrapper, formatDestinationLabel } from '@pcln/horizon-package-components'
import { calculateLengthOfStay } from '../../../details-client/util/length-of-stay'
import { buildAHCrossSellUrl, getEffectiveCheckInDate, logAHCrossSellEvent } from './helpers'

const handleViewPromotion = (ecommerce) => {
  logAHCrossSellEvent('view_promotion', { ecommerce })
}

const handleSelectPromotion = (ecommerce) => {
  logAHCrossSellEvent('select_promotion', { creative_slot: 'add_hotel', ecommerce })
}

export function AHCrossSellModal({
  returningFrom,
  destination,
  pclnBootstrapData,
  listingsMetaData,
  selectedDepartureSummaries,
  pendingSelection,
  travelDate,
  returnDate,
  isDesktop,
  originAirport,
  destinationAirport,
  totalPassengerCount,
  onDismiss,
  onCloseModal,
}) {
  const outboundItinerary = selectedDepartureSummaries?.[0]
  const returnItinerary = pendingSelection?.itinerary
  const arrivalDateTime = outboundItinerary?.slices?.[0]?.arrivalInfo?.time?.dateTime

  const handleAddHotel = () => {
    const link = buildAHCrossSellUrl({
      pclnBootstrapData,
      outboundItinerary,
      returnItinerary,
      flySessionKey: listingsMetaData?.searchSessionKey,
    })
    onCloseModal()
    window.open(link, '_blank')
  }

  return (
    <HotelCrossSellModalWrapper
      destination={formatDestinationLabel(returningFrom, destination)}
      onAddHotel={handleAddHotel}
      onDismiss={onDismiss}
      onViewPromotion={handleViewPromotion}
      onSelectPromotion={handleSelectPromotion}
      lengthOfStay={calculateLengthOfStay(getEffectiveCheckInDate(travelDate, arrivalDateTime), returnDate)}
      noOfTravelers={totalPassengerCount}
      isDesktop={isDesktop}
      itinerary={pendingSelection?.itinerary}
      originAirport={originAirport}
      destinationAirport={destinationAirport}
      travelDate={travelDate}
    />
  )
}
